import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type User, useAuth } from "features/auth";
import { api } from "utils/api";

type AdminWalletDeleteRequest = {
  userId: string;
  walletId: string;
};

const postAdminWalletDelete = (req: AdminWalletDeleteRequest) =>
  api.post<User>("/admin/wallet/delete", {
    body: JSON.stringify(req),
  });

const useAdminWalletDelete = () => {
  const { user, refreshAuth } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: postAdminWalletDelete,
    onSuccess: (response) => {
      if (user?.id === response.id) {
        refreshAuth();
      }

      queryClient.invalidateQueries({ queryKey: ["admin-user", response.id] });
    },
  });
  return mutation;
};

export { useAdminWalletDelete };
